// Same as element.scrollIntoView() but offset the scroll position by the height of the offsetSelector element.
import {modal$} from '../stores/store-main.ts';

export function scrollIntoView(
  element: HTMLElement,
  offsetSelector = 'element-header',
) {
  const offsetElementRect = document
    .querySelector(offsetSelector)
    .getBoundingClientRect();
  window.scroll({
    top: element.offsetTop - offsetElementRect.height,
    left: 0,
  });
}

export function scrollToTop() {
  document.querySelector('#main').scrollTo(0, 0);
}

export function scrollToTopSmooth() {
  document
    .querySelector('#main')
    .scrollTo({top: 0, left: 0, behavior: 'smooth'});
}

export function scrollingElement(event: Event) {
  const element = event.target as HTMLElement;
  return element.scrollTop > 0;
}

// FIXME: there is certainly a better way than passing no argument
// and relying on some query at the DOM level.
export function hideModalOnOutsideClick() {
  const ignoreElements = [
    '[data-cy="filter-btn"]',
    '[data-cy="goToOldMap-btn"]',
    '[data-cy="logout-btn"]',
    '.popup',
  ];
  const backdrop = document.querySelector('.modal-backdrop');
  const header = document.querySelector('element-header');
  const handler = (event: Event) => {
    const ignore = !!ignoreElements.filter((query) =>
      document.querySelector(query)?.contains(<Node>event.target),
    ).length;
    if (ignore) return;
    backdrop.removeEventListener('click', handler);
    header.removeEventListener('click', handler);
    modal$.next(undefined);
  };
  backdrop.addEventListener('click', handler);
  header.addEventListener('click', handler);
}

// elements pass as a callback to be sure that the element created when the event added
export function hideOnOutsideClick(
  getElementsCallback: () => HTMLElement[],
  hideCallback: () => void,
) {
  const body = document.querySelector('body');
  const handler = (event: Event) => {
    const ignore = !!getElementsCallback().filter((e) =>
      e?.contains(<Node>event.target),
    ).length;
    if (ignore) return;
    body.removeEventListener('click', handler);
    hideCallback();
  };
  body.addEventListener('click', handler);
}

export type BrowserCode =
  | 'firefox'
  | 'opera'
  | 'ie'
  | 'edge'
  | 'chrome'
  | 'safari'
  | 'unknown';

export function getBrowserCode(): BrowserCode {
  let sBrowser: BrowserCode = 'unknown';
  const sUsrAg = navigator.userAgent;
  if (sUsrAg.indexOf('Firefox') > -1) {
    sBrowser = 'firefox';
  } else if (sUsrAg.indexOf('Opera') > -1) {
    sBrowser = 'opera';
  } else if (sUsrAg.indexOf('Trident') > -1) {
    sBrowser = 'ie';
  } else if (sUsrAg.indexOf('Edge') > -1) {
    sBrowser = 'edge';
  } else if (sUsrAg.indexOf('Chrome') > -1) {
    sBrowser = 'chrome';
  } else if (sUsrAg.indexOf('Safari') > -1) {
    sBrowser = 'safari';
  }

  return sBrowser;
}

export function waitForElement(
  selector: string,
  parent: HTMLElement,
): Promise<{element: Element; bbox: DOMRect}> {
  return new Promise((resolve) => {
    if (parent.querySelector(selector)) {
      const el = parent.querySelector(selector);
      return resolve({element: el, bbox: el.getBoundingClientRect()});
    }

    const observer = new MutationObserver(() => {
      if (parent.querySelector(selector)) {
        const el = parent.querySelector(selector);
        resolve({element: el, bbox: el.getBoundingClientRect()});
        observer.disconnect();
      }
    });

    observer.observe(parent, {childList: true, subtree: true});
  });
}

export function getStyleNumberValue(element: Element, property: string): number;
export function getStyleNumberValue(
  element: Element,
  property: string[],
): number[];
export function getStyleNumberValue(
  element: Element,
  property: string | string[],
): number | number[] {
  const style = getComputedStyle(element);
  if (Array.isArray(property)) {
    return property.map((p) => {
      const value = style.getPropertyValue(p);
      return Number(value.replace('px', ''));
    }) as number[];
  } else {
    const value = style.getPropertyValue(property);
    return Number(value.replace('px', '')) as number;
  }
}
